const signedRefFor = workOrRef =>
  typeof workOrRef === 'string' ? workOrRef : (workOrRef || {}).signed_ref;

const requireSignedRef = workOrRef => {
  const signedRef = signedRefFor(workOrRef);
  if (!signedRef || !signedRef.startsWith('wk_')) {
    throw new Error('A signed work ref is required');
  }
  return signedRef;
};

const requireOwnerScreenName = work => {
  const ownerScreenName =
    (work || {}).screen_name ||
    (work || {}).owner_screen_name ||
    (work || {}).author?.screen_name;
  if (!ownerScreenName) {
    throw new Error("A work owner's screen name is required");
  }
  return ownerScreenName;
};

const withSecret = (path, secret) =>
  secret ? `${path}?secret=${encodeURIComponent(secret)}` : path;

export const buildWorkPath = (work, secret) =>
  withSecret(
    `/works/${encodeURIComponent(
      requireOwnerScreenName(work),
    )}/${encodeURIComponent(requireSignedRef(work))}`,
    secret === undefined ? (work || {}).secret : secret,
  );

export const buildNotesPath = (work, secret) =>
  withSecret(
    `${buildWorkPath(work).split('?')[0]}/notes`,
    secret === undefined ? (work || {}).secret : secret,
  );

export const buildNotePath = (work, noteID, secret) =>
  withSecret(
    `${buildNotesPath(work).split('?')[0]}/${encodeURIComponent(noteID)}`,
    secret === undefined ? (work || {}).secret : secret,
  );

export const findWorkStateBySignedRef = (works, signedRef) =>
  Object.values(works || {}).find(
    work => work && work.data && work.data.signed_ref === signedRef,
  ) || (works || {})[signedRef];
